//Import required components
import React from 'react'
import TextInput from './inputTypes/Text'
import RadioSelect from './inputTypes/Radio'
import CheckboxSelect from './inputTypes/Checkbox'

const Input = props => {

    let { label, type} = props
    let componentDict = {
        text: <TextInput {...props} />,
        radio: <RadioSelect {...props} />,
        checkbox: <CheckboxSelect {...props} />
    }

    return (
        <div className={`item`}>
            <p className='item-label'>{label}</p>
            {componentDict[type]}
        </div>
    )
}

export default Input